<template>
  <section id="menu">
    <h1>{{$t('menu.title')}}</h1>
    <vs-row vs-justify="center" vs-align="center">
      <label for>
        Customize Menu
        <br>
        <span>(if not, will list the categories)</span>
      </label>
      <vs-switch v-model="menu.customized"/>
    </vs-row>
    <vs-row vs-justify="center" vs-align="center" class="menuitems">
      <vs-list>
        <vs-list-item v-for="(item, index) in menu.items" :key="index">
          <vs-input class="inputx" placeholder="Label" v-model="menu.items[index].label"/>
          <vs-input class="inputx" placeholder="Link" v-model="menu.items[index].link"/>
          <vs-button color="danger" type="filled" @click="removeItem(index)">Remove item</vs-button>
        </vs-list-item>
        <vs-list-item>
          <vs-button color="primary" type="filled" @click="addItem">Add item</vs-button>
        </vs-list-item>
      </vs-list>
      <div id="mask" v-if="!menu.customized"></div>
    </vs-row>
    <vs-row vs-justify="center" vs-align="center">
      <vs-button color="primary" type="filled" @click="save()">Save</vs-button>
    </vs-row>
  </section>
</template>

<script>
import Menu from '../mixins/Menu.vue'

export default {
  name: 'menubuilder',

  mixins: [Menu],

  data: () => ({
    menu: {
      customized: false,
      items: []
    }
  }),

  beforeMount() {
    this.$vs.loading({ color: 'primary' })
    this.list()
  },

  methods: {
    addItem() {
      this.menu.items.push({ label: '', link: '' })
    },

    removeItem(index) {
      this.menu.items.splice(index, 1)
    },

    list() {
      this.$vs.loading({ color: 'primary' })
      this.getMenu().then(res => {
        if (!res.body) {
          this.$vs.loading.close()
          return this.$vs.dialog({
            color: 'danger',
            title: this.$t('common.error.title'),
            text: this.$t('common.error.text')
          })
        }

        this.$vs.notify({
          title: this.$t('common.success.title'),
          text: this.$t('common.success.text'),
          color: 'success'
        })

        const items = res.body
        this.menu.customized = !!items.length
        this.menu.items = items.length ? items : []
        setTimeout(this.$vs.loading.close, 1000)
      })
    },

    save() {
      this.$vs.loading({ color: 'primary' })
      this.saveMenu(this.menu.items).then(res => {
        if (!res.body) {
          this.$vs.loading.close()
          return this.$vs.dialog({
            color: 'danger',
            title: this.$t('common.error.title'),
            text: this.$t('common.error.text')
          })
        }

        this.$vs.notify({
          title: this.$t('common.success.title'),
          text: this.$t('common.success.text'),
          color: 'success'
        })

        this.menu.items = res.body
        setTimeout(this.$vs.loading.close, 1000)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.menuitems {
  position: relative;

  #mask {
    position: absolute;
    background: rgba(255, 255, 255, 0.6);
    width: 100%;
    height: 100%;
  }
}
</style>

<style lang="scss">
#menu {
  .vs-list--slot {
    margin: 20px auto;
  }
}
</style>
